import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { NewsletterSectionComponent } from '@app/widgets';
import { ContactFormSectionComponent } from '../contact-form-section/contact-form-section.component';
import { ContactHeroSectionComponent } from '../contact-hero-section/contact-hero-section.component';
import { ContactMethodsSectionComponent } from '../contact-methods-section/contact-methods-section.component';

@Component({
  selector: 'app-contact',
  imports: [
    ContactHeroSectionComponent,
    ContactFormSectionComponent,
    ContactMethodsSectionComponent,
    NewsletterSectionComponent,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Get in touch with the Capawesome team for any inquiries, feedback, or support. We are here to help you with your questions and concerns.',
    );
    this.metaService.setTitle('Contact Us');
    this.metaService.setKeywords(['contact', 'support', 'Capawesome Cloud']);
    this.jsonLdService.setStructuredData(
      JsonLdService.buildWebPageSchema(
        'Contact Us - Capawesome Cloud',
        'Get in touch with the Capawesome team for any inquiries, feedback, or support.',
        'https://cloud.capawesome.io/contact/',
        'ContactPage',
      ),
    );
  }
}
